import React, { useContext } from 'react';
import Page from './Common/Page';
import { Row, Col, Button } from 'reactstrap';
import { redirectToLoginPage } from '../Utils/AuthenticationHandler';
import qs from 'qs';
import { AuthContext } from '../Data/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

function UnauthorizedPage(props) {
    const location = useLocation();

    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const redirectTo = query.redirectTo || "/news";
    const auth = useContext(AuthContext);

    if (auth.isAuthenticated) {
        return <Navigate to={redirectTo} />;
    }

    return (
        <Page centered>
            <h2>Bejelentkezés szükséges</h2>
            <Row>
                <Col>
                    <p>Az oldal megtekintéséhez be kell jelentkezned.</p>
                    <Button color="primary" onClick={()=> redirectToLoginPage(redirectTo)}>Bejelentkezés</Button>
                </Col>
            </Row>
        </Page>
    );
}

export default UnauthorizedPage;
